module.exports = __webpack_public_path__ + "media/images/app-logo-674bb9eb21e76e4632b2a0debb8298ec.svg";